import { makeStyles } from "@material-ui/core/styles";

export const formStyles = makeStyles((theme) => ({
  formControl: {
    padding: theme.spacing(3),
  },
  button: {
    margin: theme.spacing(0, 0, 0, 1),
  },
  divider: {
    margin: theme.spacing(1, 0),
  },
  radio: {
    marginBottom: theme.spacing(0),
  },
  field: {
    marginBottom: theme.spacing(2),
  },
  secretsTitle: {
    fontWeight: "bold",
  },
  secretsText: {
    fontSize: ".85rem",
    marginBottom: theme.spacing(1),
  },
}));
